import React from 'react';
import { ProfileHero } from '../../components/ecosystem/ProfileHero';
import { CognocracyPurpose } from '../../components/cognocracy/CognocracyPurpose';
import { CognocracyFramework } from '../../components/cognocracy/CognocracyFramework';
import { CognocracyPlatform } from '../../components/cognocracy/CognocracyPlatform';
import { CognocracyGovernment } from '../../components/cognocracy/CognocracyGovernment';
import { CognocracyResearch } from '../../components/cognocracy/CognocracyResearch';
import { CognocracyMaterials } from '../../components/cognocracy/CognocracyMaterials';
import { ecosystemEntries } from '../../data/ecosystem';
const entry = ecosystemEntries.find(item => item.slug === 'cognocracy')!;
export function CognocracyPage() {
  return <>
      <ProfileHero entry={entry} subtitle="Developing human capability. Advancing civic judgment." intro="Cognocracy is a SyNeural initiative exploring how connected knowledge, human development and institutional learning can support civic governance. It brings assessment, development pathways and credentials into a broader framework for readiness and public responsibility." stage="A SyNeural initiative under development." primary={{
      label: 'Explore the framework',
      href: '#framework'
    }} secondary={{
      label: 'See the Government solution',
      href: '/government'
    }} data-id="element-2986" data-mp="akd8srjthl98" />
      <CognocracyPurpose data-id="element-2987" data-mp="na3bj3om9o08" />
      <CognocracyFramework data-id="element-2988" data-mp="nbo3cljjqsue" />
      <CognocracyPlatform data-id="element-2989" data-mp="nbei1b9g59v1" />
      <CognocracyGovernment data-id="element-2990" data-mp="rc803o07jug0" />
      <CognocracyResearch data-id="element-2991" data-mp="rchr9ewzo7na" />
      <CognocracyMaterials data-id="element-2992" data-mp="rboloh9rno6q" />
    </>;
}